import { Container, Divider, Stack, Title } from "@mantine/core";
import type { ReactElement } from "react";
import { useTranslation } from "react-i18next";

import { ModulesPending } from "../features/modules/ModulesPending";
import { useEnabledModules } from "../features/modules/useEnabledModules";
import { OrganizationNameSection } from "../features/organizationSettings/OrganizationNameSection";
import { RetryBudgetSection } from "../features/organizationSettings/RetryBudgetSection";

// Страница `/settings/organization` — раздел ядра: название организации
// видно без прикладных модулей (ADR-0085). Секция бюджета повторов
// принадлежит модулю settings и показывается только когда он включён
// (ADR-0084); пока состав модулей неизвестен — ожидание, а не «секции
// нет».
export function SettingsOrganizationPage(): ReactElement {
  const { t } = useTranslation();
  const modules = useEnabledModules();

  return (
    <Container py="xl">
      <Stack gap="md">
        <Title order={1}>{t("settings.organizationTitle")}</Title>
        <OrganizationNameSection />
        {modules.status !== "ready" ? (
          <ModulesPending state={modules} />
        ) : modules.isEnabled("settings") ? (
          <>
            <Divider />
            <RetryBudgetSection />
          </>
        ) : null}
      </Stack>
    </Container>
  );
}
